import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../../../../models/User';
import { ChartData } from '../../../charts/models/ChartData';
import { templateParseHandler } from '../../../../../utils';

@Component({
  selector: 'domain-referral-traffic',
  templateUrl: './referral-traffic.html',
  styleUrls: ['./referral-traffic.css']
})
export class DomainReferralTraffic implements OnInit {
  @Input() domain;
  @Input() region;
  @Input() device;
  @Input() data: any;
  @Input() isFollowing: boolean;

  headers = [];
  lineChartData: Array<ChartData> = [];
  tooltipData = {
    Search:
      "The percent of this domain's traffic that comes from search engines",
    Direct:
      "The percent of this domain's traffic that comes from a user directly typing the web address in their browser or clicking an existing bookmark",
    Display:
      "The percent of this domain's traffic that comes from display advertising",
    Social: "The percent of this domain's traffic that comes from social media",
    Email: "The percent of this domain's traffic that comes from email",
    Discovery:
      "The percent of this domain's traffic that comes from widgets or links to this site from other websites",
    Paid: "The percent of this domain's traffic that comes from paid traffic generation sources"
  };

  get isFreemium(): boolean {
    return this.userService.isFreemium();
  }

  constructor(private userService: User) {}

  ngOnInit() {
    this.headers = [];
    this.headers.push({
      class: 'col-4',
      text: 'DOMAIN NAME',
      key: 'pageReferrers'
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: '',
      key: 'totalTrafficRatio'
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: '',
      key: 'givtSivtRate'
    });
    this.headers.push({
      class: 'col text-xs-right',
      text: '',
      key: 'nonGivtSivtViewability'
    });

    if (this?.data?.trafficDistribution?.byMonth) {
      let graphData = JSON.parse(
        JSON.stringify(
          this?.data?.trafficDistribution?.byMonth,
          templateParseHandler
        )
      );
      graphData.reverse();
      let chartData = [];
      let trafficSourcesMapping = {};
      for (var i = 0; i < graphData.length; i++) {
        var chartObject = { month: graphData[i].month };
        var trafficSources = graphData[i].trafficSources;
        for (var j = 0; j < trafficSources.length; j++) {
          var ts = trafficSources[j];
          chartObject[ts.trafficSource] = ts.totalTrafficRatio;
          trafficSourcesMapping[ts.trafficSource] = ts.trafficSource;
        }
        chartData.push(chartObject);
      }

      this.lineChartData = chartData;
    }
  }
}
